export enum RoleType {
  All = 0,
}

export interface RolesOption {
  value: number;
  label: string;
}

export interface User {
  id: number;
  createTime: string;
  department: string;
  name: string;
  roleId: RoleType;
  expireTime: number;
  validity: string;
}

export interface SearchParams {
  type: number;
  username?: string;
  departments?: string[];
  validity?: number
}
